export default "__VITE_ASSET__7074902f__"